import View from 'view/base';

export default View.extend({
    tagName: 'section',

    render: function() {
        var content =
        '<main class="xlarge">' +
            '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
            '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
            '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
            '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
            '<div class="loader-placeholder-medium"></div>' +
        '</main>';

        this.$el.html(content);

        return this;
    }
});